class Order {
    constructor(apiService = null) {
        this.obj_name = 'order';
        this.apiService = apiService; // 將 ApiService 實例儲存為屬性
    }

    // 共用的 API 呼叫方法
    async callApi(method, endpoint, parameter = {}, progressEvent = null) {
        const apiConfig = {
            url: `${this.apiService.url}${this.obj_name}/${endpoint}`,
            parameter,
        };

        return new Promise((resolve) => {
            if (method === 'get') {
                apiConfig.url += `?${this.apiService.getMethodEncryp(parameter)}`;
                this.apiService.getApi({
                    url: apiConfig.url,
                    success: resolve,
                    error: (res) => {
                        console.log('error:', res);
                        resolve(res);
                    },
                });
            } else if (method === 'post') {
                this.apiService.postApi({
                    url: apiConfig.url,
                    parameter: apiConfig.parameter,
                    success: resolve,
                    progress: (res) => {
                        console.log(res);
                        if (progressEvent) {
                            progressEvent(res);
                        }
                    },
                    error: (res) => {
                        console.log('error:', res);
                        resolve(res);
                    },
                });
            } else if (method === 'put') {
                this.apiService.putApi({
                    url: apiConfig.url,
                    parameter: apiConfig.parameter,
                    success: resolve,
                    progress: (res) => {
                        console.log(res);
                        if (progressEvent) {
                            progressEvent(res);
                        }
                    },
                    error: (res) => {
                        console.log('error:', res);
                        resolve(res);
                    },
                });
            } else if (method === 'delete') {
                this.apiService.delApi({
                    url: apiConfig.url,
                    parameter: apiConfig.parameter,
                    success: resolve,
                    error: (res) => {
                        console.log('error:', res);
                        resolve(res);
                    },
                })
            }
        });
    }

    initFormDataValue(order_type,data){

        if ( order_type == 1 ){
            return this.initRemovableFormValue(data)
        }
        if ( order_type == 2 ){
            return this.initFixedFormValue(data)
        }
    }

    initFixedFormValue(data){
        data.teeth_tray = data.teeth_tray == 1 ? true : false
        data.teeth_tray_btm = data.teeth_tray_btm == 1 ? true : false

        data.wax_extraction = data.wax_extraction == 1 ? true : false
        data.wax_extraction_btm = data.wax_extraction_btm == 1 ? true : false

        data.cobalt_chrome_alloy = data.cobalt_chrome_alloy == 1 ? true : false
        data.cobalt_chrome_alloy_btm = data.cobalt_chrome_alloy_btm == 1 ? true : false

        data.titanium_alloy = data.titanium_alloy == 1 ? true : false
        data.titanium_alloy_btm = data.titanium_alloy_btm == 1 ? true : false

        data.titanium = data.titanium == 1 ? true : false
        data.titanium_btm = data.titanium_btm == 1 ? true : false

        data.soft_bed = data.soft_bed == 1 ? true : false
        data.soft_bed_btm = data.soft_bed_btm == 1 ? true : false

        data.btm_soft_bed = data.btm_soft_bed == 1 ? true : false
        data.btm_soft_bed_btm = data.btm_soft_bed_btm == 1 ? true : false

        data.sort_teeth_frp = data.sort_teeth_frp == 1 ? true : false
        data.sort_teeth_frp_btm = data.sort_teeth_frp_btm == 1 ? true : false

        data.sort_teeth_resin = data.sort_teeth_resin == 1 ? true : false
        data.sort_teeth_resin_btm = data.sort_teeth_resin_btm == 1 ? true : false

        data.packing = data.packing == 1 ? true : false

        data.physical_model = data.physical_model == 1 ? true : false
        data.digital_model = data.digital_model == 1 ? true : false

        return data
    }
    initRemovableFormValue(data){
        
        data.zirconia = data.zirconia == 1 ? true : false
        data.glass_ceramics = data.glass_ceramics == 1 ? true : false
        data.composite = data.composite == 1 ? true : false
        data.other_materoal = data.other_materoal == 1 ? true : false
        data.veneer = data.veneer == 1 ? true : false
        data.implant = data.implant == 1 ? true : false
        data.access_hole = data.access_hole == 1 ? true : false
        data.cd = data.cd == 1 ? true : false
        data.inlay = data.inlay == 1 ? true : false
        data.color_nosplit = data.color_nosplit == 1 ? true : false
        data.color_split = data.color_split == 1 ? true : false
        data.physical_model = data.physical_model == 1 ? true : false
        data.digital_model = data.digital_model == 1 ? true : false
        data.confirm_dentrue_style = data.confirm_dentrue_style == 1 ? true : false
        
        return data
    }
    
    // API 方法
    async addOrder(parameter,progressEvent=null){
        return this.callApi('put', 'addOrder', parameter , progressEvent);
    }

    async getOrderInfo(parameter){
        return this.callApi('get', 'getOrderInfo', parameter);
    }

    async getOrderDenture(parameter){
        return this.callApi('get', 'getOrderDenture', parameter);
    }

    //訂單 - 訂單媒合牙技所
    async addAssignMatch(parameter,progressEvent=null){
        return this.callApi('put', 'addAssignMatch', parameter , progressEvent);
    }

    async updClinicOrderSend(parameter,progressEvent=null){
        return this.callApi('put', 'updClinicOrderSend', parameter , progressEvent);
    }

    async getOrderHistory(parameter){
        return this.callApi('get', 'getOrderHistory', parameter);
    }

    async getClinicOrderSendInfo(parameter){
        return this.callApi('get', 'getClinicOrderSendInfo', parameter);
    }

    //訂單 - 取得診所待確認訂單
    async geClinicWaitlOrder(parameter){
        return this.callApi('get', 'geClinicWaitlOrder', parameter);
    }

    //訂單 - 取得診所未建立完成訂單
    async geClinicNotFinishOrder(parameter){
        return this.callApi('get', 'geClinicNotFinishOrder', parameter);
    }
    //訂單 - 取得牙技所待診所確認訂單
    async geClinicWaitConfirmOrder(parameter){
        return this.callApi('get', 'geClinicWaitConfirmOrder', parameter);
    }

    async getAllStatusOrderByClinicWithOrderAndPatient(parameter){
        return this.callApi('get', 'getAllStatusOrderByClinicWithOrderAndPatient', parameter);
    }
    //以期望預計完成日期進行搜尋
    async getAllOrderByClinicWithKeywordDate(parameter){
        return this.callApi('get', 'getAllOrderByClinicWithKeywordDate', parameter);
    }

    async getAllOrderByClinicWithOrderAndPatient(parameter){
        return this.callApi('get', 'getAllOrderByClinicWithOrderAndPatient', parameter);
    }

    async updOrderAssign(parameter,progressEvent=null){
        return this.callApi('put', 'addAssignMatch', parameter , progressEvent);
    }

    async delDentlabMatch(parameter){
        return this.callApi('delete', 'delDentlabMatch', parameter);
    }

    async getDentlabStyleInfo(parameter){
        return this.callApi('get', 'getDentlabStyleInfo', parameter);
    }

    async updOrderStatus(parameter,progressEvent=null){
        return this.callApi('put', 'updOrderStatus', parameter , progressEvent);
    }

    async getDentlabOrderSendInfo(parameter){
        return this.callApi('get', 'getDentlabOrderSendInfo', parameter);
    }

    async addOrDelOrderCollaboratorByJson(parameter,progressEvent=null){
        return this.callApi('put', 'addOrDelOrderCollaboratorByJson', parameter , progressEvent);
    }

    async clinicCancelOrder(parameter,progressEvent=null){
        return this.callApi('put', 'clinicCancelOrder', parameter , progressEvent);
    }

    async clinicCancelOrderWaitDentlab(parameter,progressEvent=null){
        return this.callApi('put', 'clinicCancelOrderWaitDentlab', parameter , progressEvent);
    }
    async cancelOrder(parameter,progressEvent=null){
        return this.callApi('put', 'cancelOrder', parameter , progressEvent);
    }

    async clinicConfirmDenture(parameter,progressEvent=null){
        return this.callApi('put', 'clinicConfirmDenture', parameter , progressEvent);
    }

    async finishOrder(parameter,progressEvent=null){
        return this.callApi('put', 'finishOrder', parameter , progressEvent);
    }

    async updOrderAndWaitConfirm(parameter,progressEvent=null){
        return this.callApi('put', 'updOrderAndWaitConfirm', parameter , progressEvent);
    }

    async orderReset(parameter,progressEvent=null){
        return this.callApi('put', 'orderReset', parameter , progressEvent);
    }

    async redoOrder(parameter,progressEvent=null){
        return this.callApi('put', 'redoOrder', parameter , progressEvent);
    }
    
    async getNewModifyOrderInfo(parameter){
        return this.callApi('get', 'getNewModifyOrderInfo', parameter);
    }
    async getNewModifyOrderDenture(parameter){
        return this.callApi('get', 'getNewModifyOrderDenture', parameter);
    }

    async AIDentlabForm(parameter,progressEvent=null){
        return this.callApi('put', 'AIDentlabForm', parameter , progressEvent);
    }

    async getAllOrderByDentlabWithPatientID(parameter){
        return this.callApi('get', 'getAllOrderByDentlabWithPatientID', parameter);
    }

    async getAllOrderByClinicWithKeyword(parameter){
        return this.callApi('get', 'getAllOrderByClinicWithKeyword', parameter);
    }
}

export default Order;
